export default __webpack_public_path__ + "240c9232e22cccc42bb3e00c56a0ed4d.svg";